/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { DropDown, DropDownList, Input, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { TranslateFilterModel } from 'models/translateWorkplace';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, FormGroup, Row } from 'reactstrap';

export default function TranslateFilter({
    brandList,
    loadingBrands,
    translateCodeList,
    loadingTranslateCodes,
    dictList,
    loadingDicts,
}: {
    brandList: DropDown[];
    loadingBrands: boolean;
    translateCodeList: DropDown[];
    loadingTranslateCodes: boolean;
    dictList: DropDown[];
    loadingDicts: boolean;
}) {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<TranslateFilterModel>();
    const { t } = useTranslation();

    const changeInputProp = (e: ChangeEvent<HTMLInputElement>) =>
        changeProp(e.target.value, e.target.name);

    const changeProp = (value: string | DropDown, name: string) =>
        setDraftFilter((prevState) => ({ ...prevState, [name]: value }));

    const chooseOption = (value: DropDown, name: keyof TranslateFilterModel) => {
        setDraftFilter((prevState) => ({ ...prevState, [name]: value.id || value.name }));
    };

    return (
        <>
            <>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <DropDownList
                                value={draftFilter.brandCode ?? ''}
                                label={t('BackOfficeBrandName')}
                                setValue={(value) => chooseOption(value, 'brandCode')}
                                items={brandList}
                                isLoading={loadingBrands}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <DropDownList
                                value={draftFilter.type ?? ''}
                                label={t('BackOfficeTranslateGroup')}
                                setValue={(value) => chooseOption(value, 'type')}
                                items={translateCodeList}
                                isLoading={loadingTranslateCodes}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <Input
                        id="ds-code-id"
                        name="name"
                        placeholder={t('BackOfficeAll')}
                        type="text"
                        value={draftFilter.name ?? ''}
                        onChange={changeInputProp}
                        label={t('BackOfficeTranslateCode')}
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        id="ds-value-id"
                        name="value"
                        placeholder={t('BackOfficeAll')}
                        type="text"
                        value={draftFilter.value ?? ''}
                        onChange={changeInputProp}
                        label={t('BackOfficeTranslateValue')}
                    />
                </FormGroup>
                <Row>
                    <Col>
                        <DropDownList
                            value={draftFilter.dictCode ?? ''}
                            label={t('BackOfficeDict')}
                            setValue={(value) => chooseOption(value, 'dictCode')}
                            items={dictList}
                            isLoading={loadingDicts}
                        />
                    </Col>
                </Row>
                <Row>
                    <FormGroup>
                        <Input
                            id="ds-dict-item-code-id"
                            name="dictItemCode"
                            type="text"
                            value={draftFilter.dictItemCode ?? ''}
                            onChange={changeInputProp}
                            label={t('BackOfficeDictItem')}
                        />
                    </FormGroup>
                </Row>
            </>
        </>
    );
}
